<script>
import bem from '@/utils/bem';

const b = bem('big-count-input');
const btn = bem('btn');
export default {
  props: {
    className: String,
    inputClass: String,
    changeCount: Function,
    withoutDecInc: Boolean,
    mainCounter: Boolean,
    withInput: Boolean,
    bemCount: Function,
    btnClassName: String,
    hiddenMobileControls: Boolean,
    minSize: Boolean,
  },
  methods: {
    b,
    btn,
  },
};
</script>

<template>
  <div :class="b('wrapper', { mix: className, 'min-size': minSize })">
    <div :class="b('')">
      <div :class="b('controls', { mix: bemCount('controls') })">
        <button
            :class="b('btn-count', {
              mix: `${btn({
              btn: true,
              minus: true,
              'min-size': minSize,
              hidden: hiddenMobileControls,
              })} ${btnClassName}`,
              main: mainCounter,
            })"
            type="button"
            v-if="!withoutDecInc"
        />
        <span
            :class="b('count', { main: mainCounter, mix: inputClass, 'min-size': minSize })"
        >0</span>
        <button
            :class="b('btn-count', {
              mix: `${btn({
              btn: true,
              plus: true,
              'min-size': minSize,
              hidden: hiddenMobileControls,
              })} ${btnClassName}`,
              main: mainCounter,
            })"
            type="button"
            v-if="!withoutDecInc"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./bigCountInputStyle.scss">

</style>
